import Modal from 'LuxKit/Modal/Modal'
import React, { useCallback, useRef, useState } from 'react'
import { useIntl } from 'react-intl'
import JourneyV2Details from '../V2/FareFamily/JourneyV2Details'
import TabButtonsGroup from 'LuxKit/Tabs/TabButtonsGroup'
import useStateWithSetters from 'hooks/useStateWithSetters'
import TabButton from 'LuxKit/Tabs/TabButton'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

interface Props {
  departingJourney: App.JourneyV2
  returningJourney: App.JourneyV2
}

function CharterFlightDetailsModal({ departingJourney, returningJourney }: Props) {
  const intl = useIntl()
  const [fareRulesURL, setFareRulesURL] = useState<string | undefined>()
  const [fareRulesParams, setFareRulesParams] = useState<any | undefined>()

  const [currentTab, setCurrentTab] = useStateWithSetters(['departing', 'returning'])

  const modalRef = useRef<HTMLDivElement>(null)

  const onHideFareRules = useCallback(() => {
    setFareRulesURL(undefined)
    setFareRulesParams(undefined)
    modalRef.current?.scrollTo({ top: 0 })
  }, [])

  const fareRulesTitle = intl.formatMessage({
    id: 'rc7JwNhlqicj6Gc1u_na',
    defaultMessage: 'Fare Rules',
    description: 'Modal title when showing fare rules for charter flights',
  })

  const flightDetailsTitle = intl.formatMessage({
    id: 'rZJtKX6vV9LaR8Q66ZXs',
    defaultMessage: 'Flight details',
    description: 'Modal title for charter flight details in the flight search or booking flow',
  })

  const departingLabel = intl.formatMessage({
    id: '0hT10wU8lFNJ5E3QC3GR',
    defaultMessage: 'Departing',
    description: 'Tab label for departing charter flight details in the flights section',
  })

  const returningLabel = intl.formatMessage({
    id: 'kwc4CO3rxcUXxvuw6Qhv',
    defaultMessage: 'Returning',
    description: 'Tab label for returning charter flight details in the flights section',
  })

  return <Modal
    title={fareRulesURL ? fareRulesTitle : flightDetailsTitle}
    onBack={fareRulesURL ? onHideFareRules : undefined}
    ref={modalRef}
  >
    <VerticalSpacer gap={20}>
      {!fareRulesURL && <TabButtonsGroup fit="grow">
        <TabButton
          size="medium"
          isActive={currentTab === 'departing'}
          onClick={setCurrentTab.departing}
        >
          {departingLabel}
        </TabButton>
        <TabButton
          size="medium"
          isActive={currentTab === 'returning'}
          onClick={setCurrentTab.returning}
        >
          {returningLabel}
        </TabButton>
      </TabButtonsGroup>}

      {currentTab === 'departing' && <JourneyV2Details
        setFareRulesURL={setFareRulesURL}
        setFareRulesParams={setFareRulesParams}
        fareRulesURL={fareRulesURL}
        fareRulesParams={fareRulesParams}
        journey={departingJourney}
        isStandalone={false}
      />}

      {currentTab === 'returning' && <JourneyV2Details
        setFareRulesURL={setFareRulesURL}
        setFareRulesParams={setFareRulesParams}
        fareRulesURL={fareRulesURL}
        fareRulesParams={fareRulesParams}
        journey={returningJourney}
        isStandalone={false}
      />}
    </VerticalSpacer>
  </Modal>
}

export default CharterFlightDetailsModal
